// extracted by mini-css-extract-plugin
module.exports = {"item":"stories_item__9kTvF","count":"stories_count__Od1rj","story":"stories_story__HByAA","footer":"stories_footer__fBIBN"};